angular.module('NiacsProjectApp.controllers-step1', [
]).controller('AddEditCustUnitDialogCtrl',['$scope','$uibModalInstance','unit',
    function($scope,$uibModalInstance,unit){
        $scope.unit = angular.copy(unit);
        $scope.dismiss = $uibModalInstance.dismiss;
        $scope.save = function() {
            unit.label = $scope.unit.label;
            unit.description = $scope.unit.description;
            unit.external_link = $scope.unit.external_link;
            $uibModalInstance.close(unit);
        };
        $scope.addLink = function() {
            if(!$scope.unit.external_link) {
                $scope.unit.external_link = [];
            }
            $scope.unit.external_link.push({});
        };
        $scope.removeLink = function(link) {
            if(link && $scope.unit.external_link) {
                for(var i = 0; i < $scope.unit.external_link.length; i++) {
                    if(link.url === $scope.unit.external_link[i].url &&
                       link.title === $scope.unit.external_link[i].title) {
                        return $scope.unit.external_link.splice(i,1);
                    }
                }
            }
        };
}])
// this directive is only ok because the user of it is not using the AutoSaveService
.directive('unitComments',['AutoSaveService','ProjectService',function(AutoSaveService,ProjectService){
    return {
        restrict: 'E',
        templateUrl: 'partials/directives/unit-comments.html',
        scope: {
            unit: '=',
            onSave: '&',
        },
        link: function($scope) {
            $scope.$watch('unit',function(unit){
                if(unit) {
                    AutoSaveService.setup(unit,function(){
                        ProjectService.save();
                    });
                    unit.$autosave = (function(self,superFunc){
                        return function(){
                            // if the user cleared out the comments then delete them
                            if(!self.comments) {
                                delete self.comments;
                            }
                            superFunc.apply(self,arguments);
                        };
                    })(unit,unit.$autosave);
                }
            });
        }
    };
}])
.controller('UnitsCtrl',['$scope','$routeParams','$filter','$uibModal','$log','ProjectService','AutoSaveService','DialogService',
    function($scope,$routeParams,$filter,$uibModal,$log,ProjectService,AutoSaveService,DialogService) {
        $scope.isSaving = AutoSaveService.isSaving;
        $scope.allGoalsHaveObjectives = function(unit) {
            if(!unit || !unit.goals || unit.goals.length === 0) {
                return false;
            }
            for(var i = 0; i < unit.goals.length; i++) {
                if(!unit.goals[i].objectives || unit.goals[i].objectives.length === 0) {
                    return false;
                }
            }
            return true;
        };
        $scope.editCustomUnit = function(unit) {
            // open dialog
            $uibModal.open({
              templateUrl: 'partials/dialogs/add-edit-custom-unit.html',
              controller: 'AddEditCustUnitDialogCtrl',
              windowClass: 'niacs-custom-unit-dialog',
              size: 'lg',
              keyboard: false,
              backdrop: 'static',
              resolve:{
                unit: function() { return unit; },
              }
            }).result.then(function(u){
                if(!u.id) {
                    $scope.addUnit(u);
                } else {
                    ProjectService.save();
                }
            },function(){});
        };
        $scope.addCustomUnit = function() {
            $scope.editCustomUnit({});
        };
        $scope.unitSource = function(unit) {
            if (angular.isNumber(unit.id)) {
                return $scope.project && $scope.project.$vuln_region ?
                    $scope.project.$vuln_region.label : '...';
            }
            return "Custom";
        };
        // add-remove unit support (Step 1A).
        $scope.startComments = function(i) {
            // using the index of the unit to start comments for rather than the reference
            // since on save the reference can change
            ProjectService.afterSave(function(){
                $scope.project.units[i].comments = '';
            });
        };
        $scope.addUnit = function(unit) {
            niacs.info("addUnit.unit",unit);
            AutoSaveService.startSaving();
            ProjectService.addUnit($scope.project,unit).then(function(project){
                ProjectService.save();
            });
        };
        $scope.removeUnit = function(unit) {
            niacs.info("removeUnit.unit",unit);
            function doRemove() {
                if(!niacs.removeById($scope.project.units,unit.id)) {
                    $log.error("Warning unable to find unit to remove", unit);
                    return;
                }
                ProjectService.save();
            }
            if(unit) {
                if((unit.goals && unit.goals.length) || unit.comments || angular.isString(unit.id) /* always prompt for custom unit removal */){
                    var dialogContents = {
                      message: 'Are you sure you want to remove '+(unit.label||unit.$label)+'?',
                      warning: 'This cannot be undone.',
                      okText: 'Yes, remove it',
                      cancelText: 'No, keep it',
                      conditions: []
                    },objectives;
                    if(unit.goals && unit.goals.length) {
                        dialogContents.conditions.push(unit.goals.length+' goals have been defined.');
                    }
                    objectives = niacs.collectObjectives(unit,false);
                    if(objectives.length) {
                      dialogContents.conditions.push(objectives.length+ " objectives have been defined.");
                      niacs.addSafeDeleteCounts(objectives,dialogContents);
                    }
                    if(unit.comments) {
                        dialogContents.conditions.push('You have entered comments.');
                    }
                    DialogService.safe(dialogContents).then(function() {
                      niacs.info('user confirmed removal of unit.');
                      doRemove();
                    });
                } else {
                    doRemove();
                }
            }
        };
        $scope.initNewGoalVisibility = function(context) {
            if(typeof(context.$addGoalHide) === 'undefined') {
                context.$addGoalHide = context.goals && context.goals.length;
            }
        };
        $scope.addNewGoal = function(context) {
            // this is less than ideal but to allow "add" buttons to be enabled during a save
            // and have the action work we need to search for the context in question rather
            // than simply modifying it since a save may have pulled the rug our from under us.
            ProjectService.afterSave(function(p) {
                var ctxs = p.units ? [p].concat(p.units) : [p],
                    ctx = niacs.findById(ctxs,context.id);
                if(ctx) {
                    if(!ctx.goals) {
                        ctx.goals = [];
                    }
                    ctx.goals.push({id: niacs.guid() });
                    ProjectService.save();
                }
            });
        };

        // add-remove goal support is embedded in the niacsGoalForm directive.
        function getContexts() {
            var project = $scope.project,units,contexts,i;
            if(project && project.$vuln_region && project.$vuln_region.$units) {
                //unit in project.units | inflate:project.$vuln_region.$units
                units = $filter('inflate')(project.units,project.$vuln_region.$units);
                contexts = [project];
                contexts = (units && units.length) ? contexts.concat(units) : contexts;
                if($scope.contexts && $scope.contexts.length === contexts.length) {
                    for(i = 1; i < contexts.length; i++) {
                        angular.extend($scope.contexts[i], contexts[i]);
                    }
                } else {
                    $scope.contexts = contexts;
                }
            }
        }

        $scope.$watch('project.$vuln_region.$units',getContexts);
        $scope.$watch('project.$updateCount',getContexts);
        ProjectService.get($routeParams,'UnitsCtrl',function(p){
            $scope.project = p;
        });
}]);
